import { render } from "./cpt-chart-pie-3d-option.vue?vue&type=template&id=e54135fa"
import script from "./cpt-chart-pie-3d-option.vue?vue&type=script&lang=js"
export * from "./cpt-chart-pie-3d-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__